import axios from 'axios';

const tenantAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
});

tenantAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('rf_tenant_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

tenantAPI.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('rf_tenant_token');
      localStorage.removeItem('rf_tenant_user');
      window.location.href = '/tenant/login';
    }
    return Promise.reject(err);
  }
);

export default tenantAPI;
